import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const supportApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadSupportTickets: builder.query({
      query: ({ id, pageSize, pageNumber }) =>
        (config.GetIssueDefectList || "") +
        id +
        "&pmId=" +
        (config.WorkflowIds?.SupportPmId || 4) +
        "&pageSize=" +
        pageSize +
        "&pageNumber=" +
        pageNumber,
      providesTags: ["Support"],
    }),
    sendSupportTicketsMessage: builder.mutation({
      query: (data) => ({
        url: config.SendSupportMessage || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Support"],
    }),
    loadSupportBprmForm: builder.query({
      query: (id) => (config.GetForm || "") + id,
      providesTags: ["Support"],
    }),
    loadSupportCurrentWorkflowTask: builder.mutation({
      query: (data) => ({
        url: config.GetCurrentWorkflowTask || "",
        method: "POST",
        body: data,
      }),
    }),
    startSupportApplication: builder.mutation({
      query: (data) => ({
        url: config.StartNewApplication || "",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useLoadSupportTicketsQuery,
  useLazyLoadSupportTicketsQuery,
  useSendSupportTicketsMessageMutation,
  useLoadSupportBprmFormQuery,
  useLazyLoadSupportBprmFormQuery,
  useLoadSupportCurrentWorkflowTaskMutation,
  useStartSupportApplicationMutation,
} = supportApiSlice;
